<acf>
  return component('fifty-fifty', [
    'sub_fields' => [
      fragment_field(),
      content_field('left_content'),
      text_field('box_1_text'),
      file_field('box_1_file'),
      text_field('box_2_text'),
      url_field('box_2_url')
    ]
  ]);
</acf>

<php>
  return function($content) {
    $content['field_FiftyFifty_left_content'] = wpautop($content['field_FiftyFifty_left_content']);
    $content['field_FiftyFifty_box_1_file'] = wp_get_attachment_url($content['field_FiftyFifty_box_1_file']);

    return $content;
  };
</php>

<script>
  export default {
    props: ['content']
  }
</script>
<template>
  <section :id="content.field_FiftyFifty_fragment_id">
    <div class="container">
      <div class="content" v-html="content.field_FiftyFifty_left_content" />
      <div class="cubes">
        <a :href="content.field_FiftyFifty_box_1_file" target="_blank" class="cube cube-download">
          <div class="square"><span>{{ content.field_FiftyFifty_box_1_text }}</span></div>
        </a>
        <a :href="content.field_FiftyFifty_box_2_url" target="_blank" class="cube cube-apply">
          <div class="square"><span>{{ content.field_FiftyFifty_box_2_text }}</span></div>
        </a>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .content {
    padding: 43px 1.5rem 55px 1.5rem;
    max-width: 768px;
    margin: 0 auto;
    @include mobile { background: $red; color: white; }
  }

  .content /deep/ h2 {
    color: white;
    margin-bottom: 1em;
    @include tablet { text-align: center; color: $red; }
  }

  // @include mobile {
  //   .content, .content /deep/ h2 {
  //     color: white;
  //   }
  // }

  .cubes {
    padding: 2rem;
    display: flex;
    max-width: 720px;
    margin: 0 auto;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 100%;
    @include desktop { flex-direction: row-reverse; }
  }

  .cube {
    background-image: url('../assets/cube.svg');
    font-size: 2.25rem;
    font-family: 'Separat';
    display: block;
    height: 277px;
    width: 300px;
    max-width: 100%;
  }

  .cube:not(:last-child) {
    margin-bottom: 71px;
  }

  .cube .square {
    width: 240px;
    height: 240px;
    display: flex;
    padding: 0 26px;
    align-items: center;
    line-height: 1.2;
  }

  .cube-download {
    background-image: url('../assets/cube-download.svg');
    color: $red;
  }

  .cube-apply {
    background-image: url('../assets/cube-apply.svg');
    color: $blue;
  }

</style>



// WEBPACK FOOTER //
// components/FiftyFifty.vue